/**
 * skip-link-focus-fix. Helps with 
 * accessibility for keyboard only users.
 *
 * @link https://git.io/vWdr2
 *
 * @since 0.0.1
 * @return {void} 
 */
export function skipLinkFocusFix() {
	let isIe = /(trident|msie)/i.test( navigator.userAgent );
	if ( isIe && document.getElementById && window.addEventListener ) {
		window.addEventListener( 'hashchange', function() {
			let id = location.hash.substring( 1 );
			if ( ! ( /^[A-z0-9_-]+$/.test( id ) ) ) {
				return;
			}
			let element = document.getElementById( id );
			if ( element ) {
				if ( ! ( /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) ) {
					element.tabIndex = -1;
				}
				element.focus();
			}
		}, false );
	}
}

/**
 * Force fixed admin bar without throwing Theme Check errors ;). 
 *
 * @since 0.0.1
 * @return {void} 
 */
export function mobileAdminBarFix() {
	const styleEl = document.createElement('STYLE');
	const styles = document.createTextNode('#wpadminbar { position: fixed; }');
	styleEl.setAttribute('type', 'text/css');
	styleEl.appendChild(styles);
	document.querySelector('head').appendChild(styleEl);
}